import { Helmet } from 'react-helmet-async';
import ContactSection from '../components/ContactSection';

export default function Contact() {
  return (
    <>
      <Helmet><title>Contact | Anas Qazi</title></Helmet>
      <ContactSection />
    </>
  );
}
